import { getEventScope } from "../../../core/event-scope/event-scope";
import { Actions } from "../../../constants/actions";
import { FormBase } from "../../../util/form-base-form";
import type { ChipPickerHandler } from "./chip-picker-handler";

class ChipPickerListenerFormBase extends FormBase {
    public getClearButtons(root: ParentNode): HTMLButtonElement[] {
        return this.queryElements(root, `[data-action="${Actions.CLEAR_ALL}"]`, HTMLButtonElement);
    }

    public getClosestClearButton(target: EventTarget | Element | null | undefined): HTMLButtonElement | null {
        return this.closest(target, `[data-action="${Actions.CLEAR_ALL}"]`, HTMLButtonElement);
    }
}

const chipPickerListenerFormBase = new ChipPickerListenerFormBase();

export interface ChipPickerListenerParams {
    rootEl: Document | HTMLElement;
    scopeKey: string;
    openBtnEl?: HTMLElement | null;
    chipsEl: HTMLElement;
    controller: ChipPickerHandler;
}

export class ChipPickerListener {
    public static setup(params: ChipPickerListenerParams): void {
        const { rootEl, scopeKey, openBtnEl, chipsEl, controller } = params;
        const scope = getEventScope(rootEl, scopeKey);
        controller.initializeUi(rootEl);

        scope.once("bind", () => {
            if (openBtnEl) {
                openBtnEl.addEventListener("click", (event) => {
                    const target = event.target instanceof HTMLElement ? event.target : null;
                    const clearBtn = chipPickerListenerFormBase.getClosestClearButton(target);
                    if (clearBtn) {
                        event.preventDefault();
                        event.stopPropagation();
                        controller.clearAll();
                        return;
                    }

                    controller.handleOpenClick(event);
                });
            }
            chipsEl.addEventListener("click", (event) => controller.handleChipsClick(event));
        });
    }
}
